<template>
  <div id="osList">
      <!-- Carregando -->
      <div v-if="empilhadeirasBloqueadas === 'loading'" class="text-center py-3 col-12">
        <i class="fas fa-spinner fa-spin mr-2"></i> {{this.$t('Carregando')}}...
      </div>

      <!-- Lista -->
      <div v-else-if="empilhadeirasBloqueadas.length">
        <div class="col-12">
          <EmpilhadeiraCardList
            :empilhadeiras="empilhadeirasBloqueadas"
            :key-api="empilhadeiraKey"
          />
        </div>
      </div>

      <!-- Nenhum resultado -->
      <div v-else class="text-center py-3 col-12">
        {{ $t('Nenhum resultado encontrado')}}.
      </div>
  </div>
</template>

<script>
import EmpilhadeiraCardList from '@/components/EmpilhadeiraCardList'

export default {
  components: {
    EmpilhadeiraCardList,
  },

  created() {
    const filial = this.$store.getters['filial/filial']
    const fifi = filial.infColab.newFilial || filial.nr_sequencial

    this.$store.commit('os/setEmpilhadeiras', 'loading')
    this.$store.dispatch('os/fetchFromApiEmpilhadeiraBloqueada', { filial: fifi })
  },

  computed: {
    empilhadeirasBloqueadas() {
      return this.$store.state.os.empilhadeirasBloqueadas
    },
    empilhadeiraKey() {
      return this.$store.state.os.empilhadeiraKey
    },
    filial() {
      return this.$store.getters['filial/filial']
    }
  }
}
</script>
